module.exports = __webpack_public_path__ + "img/news-text.bf5f894c.svg";